import type { HoldCleaningRefreshRun } from "../models/hold-cleaning.models";
import { formatHoldCleaningDate } from "./HoldCleaningUi";

// Older runs ended at publication. Do not present those timestamps as verified worker completion.
const HoldCleaningRunLifecycle = ({ run }: { run: HoldCleaningRefreshRun }) => {
  const publishedAt = run.validationSummary?.publishedAt;
  if (typeof publishedAt !== "string") return null;
  const finishedAt = run.validationSummary?.workerFinishedAt;
  return (
    <p className="mt-2 text-xs" data-test="hold-cleaning-run-lifecycle">
      Data published {formatHoldCleaningDate(publishedAt)}.{" "}
      {typeof finishedAt === "string"
        ? `Worker finished ${formatHoldCleaningDate(finishedAt)}.`
        : run.completedAt
          ? "Worker interrupted after publication; published data remains available."
          : "Worker still running image categorization; published data is already available."}
    </p>
  );
};

export default HoldCleaningRunLifecycle;
